import {
    JsonApiModel,
    Attribute,
    JsonApiModelConfig,
    JsonApiDatastore
} from 'angular2-jsonapi'

@JsonApiModelConfig({
    type: 'bandeiras'
})
export class Bandeira extends JsonApiModel {
    @Attribute() descricao: string
    @Attribute() codenome: string

    constructor(_datastore?: JsonApiDatastore, data?: any) {
        super(_datastore, data)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/bandeira.model.ts